import MainPage from "./Components/MainPage";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return <MainPage />;
}

export default App;
